/**
 * Alarm Number Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.alarmNumberFormatter = function(value, row) {
    if (rights.includes("alarms.show")) {
        return '<a href="/alarms/show/'+row.id+'">'+value+'</a>';
    } else {
        return value;
    }
};
